export class Dropdown {
    key: any;
    value: any;

    constructor() {
        // this.Key = Key;
        // this.Value = Value;
    }
}